import { create } from "superstruct";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import GrowaveConfigurationBodySchema from "./GrowaveConfigurationBodySchema";
import GrowaveConfigurationEntity from "./GrowaveConfigurationEntity";
import { GrowaveConfigurationProviderInterface } from "./GrowaveConfigurationProviderInterface";

class GrowaveConfigurationFromJsonProvider
    implements GrowaveConfigurationProviderInterface
{
    constructor(
        private readonly logger: LoggerInterface,
        private readonly additionalInfoData: unknown
    ) {}

    getConfiguration(): GrowaveConfigurationEntity {
        const growaveConfiguration = create(
            {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                ...(this.additionalInfoData as any).FEATURES,
                ...{
                    myshopifyDomain: window.Shopify?.shop || "",
                    isDiscountApplyAvailable: true,
                    isCartAvailable: true,
                },
            },
            GrowaveConfigurationBodySchema
        );
        this.logger.debug(
            "GrowaveConfigurationFromJsonProvider.getConfiguration",
            {
                growaveConfiguration: growaveConfiguration,
            }
        );
        return growaveConfiguration;
    }
}

export default GrowaveConfigurationFromJsonProvider;
